export var SortingDirection;
(function (SortingDirection) {
    SortingDirection["NONE"] = "NONE";
    SortingDirection["UP"] = "ASC";
    SortingDirection["DOWN"] = "DESC";
})(SortingDirection || (SortingDirection = {}));
export var ColumnType;
(function (ColumnType) {
    ColumnType["DATE"] = "DATE";
    ColumnType["DATETIME"] = "DATETIME";
    ColumnType["ACTIONS"] = "ACTIONS";
    ColumnType["GENERIC"] = "GENERIC";
})(ColumnType || (ColumnType = {}));
